import styled from '@emotion/styled';

import { Grid, Card, CardContent, CardHeader, Divider, useTheme } from '@mui/material';

import { BasicFlex, FullDivider } from '../../../utils/Common';

import { CardBlockContainer, CardBlock, CardBlockHeader, CardSpacer } from '../../../utils/utilities/CardComponents';

import { useFormikContext } from 'formik';

import { useFormData } from '../../../contexts/FormData';

import { formatCurrency, formatGenericDate } from '../../../utils/util';

import { methods } from '../../Payments/helpers';

import SimpleChip from '../../../utils/utilities/SimpleChip';

const SummaryTitle = styled(CardBlockHeader)`
  margin: 1.5rem 0;
`

const Totals = styled(BasicFlex)`
  background-color: ${props => props.theme.colors.darkBg};
  padding: 1rem 1.5rem;
  margin-bottom: 2rem;
  border-radius: 8px;
  border: 2px dashed ${props => props.theme.colors.border};
`;

const Summary = styled(BasicFlex)`
  /* background-color: ${props => props.theme.colors.darkBg};
  border-radius: 5px;
  border: 1px solid ${props => props.theme.colors.border};
  padding: 2rem; */
  padding: 1rem 0;
`

const SummaryLine = styled(BasicFlex)`
  margin-bottom: 1rem;
  padding-bottom: 0;
  /* width: 28rem; */
  font-size: 1.6rem;
  font-weight: 400;
  /* align-items: center; */
  /* background-color: green; */

  .total {
    font-weight: 600;
  }
`

const SummarySpacer = styled.div`
  margin: 2rem 0;
`

const SubSummaryLine = styled(SummaryLine)`
  /* border: 1px solid ${props => props.theme.colors.border}; */
  background-color: ${props => props.theme.colors.darkBg};
  font-size: 1.4rem;
  margin-bottom: 1rem;
  padding: .6rem 1rem;
  border-radius: 3px;
  /* width: 28rem; */
`;

const TotalAmount = styled.div`
  font-size: 2rem;
  font-weight: 600;
`;

const BalanceAmount = styled.div`
  color: ${props => props.$color};
  font-weight: 500;
`

const TotalAmountLabel = styled.div`
  font-size: 1.5rem;
  font-weight: 500;
  color: ${props => props.theme.colors.mildText};
  text-transform: uppercase;
`;

const getStatus = (amount, balance) => {
  let status = "success";
  if (!balance || balance <= 0) return status;
  if (+amount === 0) { 
    status = "error";
  } else if (amount < balance) {
    status = "warning";
  } else {
    status = "success";
  }
  return status;
}

const Sidebar = () => {
  const { values } = useFormikContext() || {};
  const { formValues } = useFormData() || {};

  const theme = useTheme();

  let method = methods.find(el => el.value === values?.method)?.label;

  const balanceDetails = [
    { header: "Amount Received", info: values.amount, dataType: "currency" },
    { header: "Balance", info: values.final_balance, dataType: "currency" },
  ];

  const vendorDetails = [
    { header: "Vendor", info: formValues.vendor_name },
  ]

  const paymentDetails = [
    { header: "Payment Type", info: method },
    { header: "Payment Date", info: values.date, dataType: "date" },
  ]

  let applied_amount = !formValues.applied_payments?.length ? 0 : formValues.applied_payments?.filter(el => el?.selected && el?.title)?.reduce((acc, el) => acc + +el?.amount, 0);
  let credit_amount = +values.amount - applied_amount;


  
  return (
    <Card variant='outlined'>
      <CardHeader title="Payment Summary" />
      <CardContent >

        <Totals dir="column" align="flex-end">
          <SummaryLine dir="column" align="flex-end" gap=".4rem">
            <TotalAmountLabel>Amount Received</TotalAmountLabel>
            <TotalAmount>{formatCurrency(values.amount)}</TotalAmount>
          </SummaryLine>
          <SummaryLine dir="column" align="flex-end" gap=".4rem">
            <div>Vendor Balance</div>
            {/* <SimpleChip label={formatCurrency(formValues.final_balance || 0)} palette={getStatus(values.amount, formValues.final_balance)} /> */}
            <BalanceAmount $color={theme.palette[getStatus(values.amount, formValues.final_balance)].main}>{formatCurrency(formValues.final_balance || 0)}</BalanceAmount>
          </SummaryLine>
        </Totals>

        <CardBlockContainer>
          {/* <CardBlockHeader>Payment Details</CardBlockHeader>
          {balanceDetails.map((block) => (
            <CardBlock key={block.header} {...block} />
          ))}
          <CardSpacer /> */}
          <CardBlockHeader>Vendor Details</CardBlockHeader>
          {vendorDetails.map((block) => (
            <CardBlock key={block.header} {...block} />
          ))}

          <CardSpacer />
          <CardBlockHeader>Payment Details</CardBlockHeader>
          {paymentDetails.map((block) => (
            <CardBlock key={block.header} {...block} />
          ))}
          <CardSpacer />
        </CardBlockContainer>

        <FullDivider />

        <SummaryTitle>Summary</SummaryTitle>
        <Summary dir="column" align="flex-end">
          <SubSummaryLine>
            <span>Amount Received</span>
            <span>{formatCurrency(values.amount)}</span>
          </SubSummaryLine>
          <SubSummaryLine>
            <span>Amount Applied</span>
            <span>{formatCurrency(applied_amount)}</span>
          </SubSummaryLine>
          <SubSummaryLine>
            <span>Amount Credited</span>
            <span>{formatCurrency(credit_amount)}</span>
          </SubSummaryLine>
        </Summary>
        
      </CardContent>
    </Card>
  )
};

export default Sidebar;